import { I18N } from "aurelia-i18n";
import { autoinject } from "aurelia-framework";

@autoinject
export class BooleanTextValueConverter {

    constructor(private i18n: I18N) { }

    toView(value) {
        if(value == null){
            return "";
        }
        else{
            return value ? this.i18n.tr('yes-text') : this.i18n.tr('no-text');
        }
    }
}